import { render, staticRenderFns } from "./view-MT4.vue?vue&type=template&id=3e617272&scoped=true&"
import script from "./view-MT4.vue?vue&type=script&lang=js&"
export * from "./view-MT4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e617272",
  null
  
)

export default component.exports